
  <template>
  <div class="app-wrapper">
    <!-- :class="classObj" -->
    <!-- <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    /> -->
    <!-- <el-header class="logo" >
        <img src="@/assets/dataLogo.png" alt="" v-if="color!='#000'">
        <span class="logoText">Single Genome Database</span>
    </el-header> -->
    <el-container style="height: 100vh">
      <!--  <el-aside :class="isCollapse?'closeSidebar':'openSidebar'" class="aside">
        <sidebar class="sidebar-container" :isCollapse="isCollapse"/>
      </el-aside>
      <el-container> -->
      <!-- :class="top <= 500 ? 'headerone' : 'headertwo'" -->
      <el-header class="header"  >
        <!-- :style="back=='深色'?'':'background:#5ca9c7'" -->
        <navbar
          @isCollapseFunction="isCollapseFunction"
          :isCollapse="isCollapse"
          
        />
        <div class="language">
        <el-dropdown @command="changeLanguage">
        <span class="el-dropdown-link">
           <i class="marginRight svgI">
                <svg-icon data_iconName="language" className="language_icon" class="svgIcon"
              /></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="zh">CN  简体中文</el-dropdown-item>
          <el-dropdown-item command="en">US  English</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      </div>
        <!-- :color="top ==2||top ==4 ?'rgb(15 15 15)':'#f8f3f3'" -->
        <!--<tags-view /> -->
      </el-header>
      <el-main class="app-main">
        <app-main @navChange="navChange"/>
        <el-backtop target=".app-main" :visibility-height="100"></el-backtop
        >
        <!-- <el-footer class="footer">©{{ year }} Smart Genomics Co., Ltd. All Rights Reserved</el-footer> -->
      </el-main>
        <!-- <el-footer class="footer">©{{ year }} Smart Genomics Co., Ltd. All Rights Reserved</el-footer> -->
      <!--  </el-container> -->
    </el-container>
    
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain /* TagsView */ } from "./components";
export default {
  name: "layout",
  props: {
    //传值
  },
  data() {
    return {
      isCollapse: false,
      top: 0,
      year:'',
      back:"浅色"
    };
  },
  components: {
    //引入模块
    Navbar,
    Sidebar,
    AppMain,
    /* TagsView */
  },
  watch: {
    // watch擅长处理的场景：一个数据影响多个数据
  },
  computed: {
    // computed擅长处理的场景：一个数据受多个数据影响
  },
  mounted: function () {
    // 编译好的HTML挂载到页面完成后执行的事件钩子
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    // 此钩子函数中一般会做一些ajax请求获取数据进行数据初始化
    console.log("Home");
    window.addEventListener("scroll", this.handleScroll, true);
    var year = this.getDateTime("year");
    this.year = year;
  },
  methods: {
    // 组件的方法
    navChange(e){
      console.log(e)
      // this.back=e
      this.top=e
    },
    changeLanguage(command){
      // console.log(command)
      this.$i18n.locale=command  //设置中英文模式
      localStorage.setItem('languageSet',this.$i18n.locale)  //将用户设置存储到localStorage以便用户下次打开时使用此设置
    },
    // rgba(img) {
    //   var canvas = document.createElement("canvas");
    //   canvas.width = img.width;
    //   canvas.height = img.height;

    //   var context = canvas.getContext("2d");
    //   img.crossOrigin = "Anonymous";
    //   context.drawImage(img, 0, 0, canvas.width, canvas.height);

    //   // 获取像素数据
    //   var data = context.getImageData(0, 0, img.width, img.height).data;
    //   console.log(data);
    //   var r = 1,
    //     g = 1,
    //     b = 1;
    //   // 取所有像素的平均值
    //   for (var row = 0; row < img.height; row++) {
    //     for (var col = 0; col < img.width; col++) {
    //       // console.log(data[((img.width * row) + col) * 4])
    //       if (row == 0) {
    //         r += data[img.width * row + col];
    //         g += data[img.width * row + col + 1];
    //         b += data[img.width * row + col + 2];
    //       } else {
    //         r += data[(img.width * row + col) * 4];
    //         g += data[(img.width * row + col) * 4 + 1];
    //         b += data[(img.width * row + col) * 4 + 2];
    //       }
    //     }
    //   }

    //   console.log(r, g, b);
    //   // 求取平均值
    //   r /= img.width * img.height;
    //   g /= img.width * img.height;
    //   b /= img.width * img.height;

    //   // 将最终的值取整
    //   r = Math.round(r);
    //   g = Math.round(g);
    //   b = Math.round(b);
    //   console.log(r, g, b);

    //   return [r, g, b];
    // },
    // bannerChange(e) {
    //   console.log(e);
    //   console.log(this.bannerList[e]);
    //   // this.test=this.bannerList[e].img_name
    //   //  var img = document.getElementById("scream"); //图片节点
    //   // this.bannerImage(e)
    // },
    // bannerImage(e){
    //    let img = new Image();

    //   img.crossOrigin = "";
    //   img.src = this.bannerList[e].img_name;
    //   img.src = this.bannerList[e].img_name + "?time=" + new Date().valueOf();
    //   // 允许跨域操作
    //   img.setAttribute("crossOrigin", "anonymous");
    //   var that = this;
    //   img.onload = function () {
    //     const rgb = that.rgba(img);
    //     console.log(rgb);
    //     // const RgbValue = rgb.replace('rgb(', '').replace(')', '');
    //     const RgbValueArry = rgb;
    //     const grayLevel =
    //       RgbValueArry[0] * 0.299 +
    //       RgbValueArry[1] * 0.587 +
    //       RgbValueArry[2] * 0.114;
    //     console.log(grayLevel);
    //     if (grayLevel >= 175) {
    //       console.log("浅色");
    //       that.back="浅色"
    //     } else {
    //        that.back="深色"
    //       console.log("深色");
    //     }
    //   };
    // },
    isCollapseFunction(boolean) {
      this.isCollapse = boolean;
    },
    /* handleScroll(e) {
      var top = e.target.scrollTop;
      this.top = top;
    }, */
    getDateTime(type) {
      var date = new Date();
      var hengGang = "-";
      var maoHao = ":";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var curDate = date.getDate();
      var curHours = date.getHours();
      var curMinutes = date.getMinutes();
      var curSeconds = date.getSeconds();

      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (curDate >= 0 && curDate <= 9) {
        curDate = "0" + curDate;
      }
      if (curHours >= 0 && curHours <= 9) {
        curHours = "0" + curHours;
      }
      if (curMinutes >= 0 && curMinutes <= 9) {
        curMinutes = "0" + curMinutes;
      }
      if (curSeconds >= 0 && curSeconds <= 9) {
        curSeconds = "0" + curSeconds;
      }
      var currentdate = "";
      if (type == "year") {
        currentdate = year;
        return currentdate;
      } else if (type == "month") {
        currentdate = year + hengGang + month;
        return currentdate;
      } else {
        currentdate =
          year +
          hengGang +
          month +
          hengGang +
          curDate +
          " " +
          curHours +
          maoHao +
          curMinutes +
          maoHao +
          curSeconds;
        return currentdate;
      }
    },
  },
  beforeCreate: function () {
    // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  },
  created: function () {
    // 实例已经创建完成之后被调用。在这一步，实例已完成以下的配置：数据观测(data observer)，属性和方法的运算， watch/event 事件回调。然而，挂载阶段还没开始，el 属性目前不可见。
  },
  beforeMount: function () {
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  beforeUpdate: function () {
    // 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
  },
  updated: function () {
    // 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    // 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。然而在大多数情况下，你应该避免在此期间更改状态，因为这可能会导致更新无限循环。
    // 该钩子在服务器端渲染期间不被调用。
  },
  beforeDestroy: function () {
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
  },
  destroyed: function () {
    // Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，所有的事件监听器会被移除，所有的子实例也会被销毁。 该钩子在服务器端渲染期间不被调用。
  },
};
</script>
<style scoped>
.header {
  height: 70px !important;
  padding: 0 260px;
  /* position: fixed; */
  z-index: 10000;
  border-bottom: 2px solid #083090;
}
.headerone {
  color: rgba(255, 255, 255, 1);
  box-shadow: none;
  transition: 0.4s background-color, color 0.4s;
  /* background: #479ec0; */
  /* background: linear-gradient(to right, #515fe261 ,#14899b75 ); */
  /* background: rgb(57 87 98 / 55%); */
  
}
.headertwo {
  color: #000;
  box-shadow: none;
  transition: 0.4s background-color, color 0.4s;
  /* background: #479ec0; */
  background: transparent;
}
.aside {
  background-color: rgb(238, 241, 246);
}
.openSidebar {
  width: 200px !important;
}
.closeSidebar {
  width: 65px !important;
}
.app-main {
  padding: 0;
  overflow-x: hidden;
  background: #eee;
}
.footer{
  /* display: flex; */
  /* justify-content: center; */
  width: 100%;
  /* height: 100px !important; */
  /* background: rgba(8, 138, 105, 0.8); */
  /* margin-top: 40px !important; */
  /* margin: 0 auto; */
  /* align-items: center; */
  /* position: relative; */
  background: #eee;
  text-align: center;

}
iframe{
  width: 500px;
  height: 200px;
  /* margin: 0 auto; */
    /* width: 100%; */
  /* margin-left: -20px; */
  pointer-events: none;
}
.logo img{
    width: 15%;
    margin-left: 223px;
  
}
.logo{
  height: 102px !important;
  display: flex;
    align-items: center;
    /* background: url('@/assets/logoBg.jpg'); */
    background: #4798cf;

}
.logoText{
  font-size: 41px;
  margin-left: 41px;
  font-weight: bold;
    color: #f8f8f8;
    font-style: italic;
}
.language{
      display: inline-block;
    /* float: right; */
    position: relative;
    /* right: 5px; */
    left: 115%;
    top: -45px;
}
</style>